import React, { FC, useState, useEffect, useRef } from 'react';
import { Icons } from '@components/Icon';
import { secondsToHMS } from '@utils/time.utils';
import {
    Capitol,
    CapitolIcon,
    CapitolTime,
    CapitolTitle,
    Capitols,
    Record,
    RecordPlayer,
    Title,
    Wrapper,
} from './TrainingRecord.elements';
import { calendarApi } from '../../services/calendar.service';

export interface TrainingRecordProps {
    chapters: {
        time: number;
        title: string;
    }[];
    lecturersKey: string[];
    video: {
        url: string;
        _key: string;
    }
}

const TrainingRecordTemplate: FC<TrainingRecordProps> = ({ chapters, lecturersKey, video }) => {

    const [currentTime, setCurrentTime] = useState(0);
    const [currentElement, setCurrentElement] = useState(null);

    const watchedSecondsRef = useRef(new Set());

    //priebezne odosielanie
    const sendWatchedSeconds = async () => {

        const secondsToSend = [...watchedSecondsRef.current];

        if (secondsToSend.length === 0) {
            return;
        }

        watchedSecondsRef.current.clear();

        const data = {
            secondsWatched: secondsToSend,
            lecturers: lecturersKey
        }

        await calendarApi.saveWatchedSecondsToVideo(video?._key, data);

    };

    useEffect(() => {
        if (currentElement) {
            setCurrentTime((currentElement as HTMLVideoElement).currentTime);

            const handleTimeUpdate = () => {
                watchedSecondsRef.current.add(
                    Math.floor(currentElement.currentTime)
                );
            };

            currentElement.addEventListener(
                'timeupdate',
                () => {
                    setCurrentTime((currentElement as HTMLVideoElement).currentTime);

                    handleTimeUpdate();

                }
            );

            const intervalId = setInterval(() => {
                sendWatchedSeconds();
            }, 30000);

            currentElement.addEventListener('ended', sendWatchedSeconds);

            currentElement.addEventListener(
                'play',
                () => {
                    setCurrentTime((currentElement as HTMLVideoElement).currentTime);
                },
                { once: true }
            );

            return () => {
                clearInterval(intervalId);
                currentElement.removeEventListener('timeupdate', handleTimeUpdate);
            };

        }
    }, [currentElement]);

    useEffect(() => {
        const interval = setInterval(() => {
            const element = document.getElementById(`video-${video?._key}`);

            if (element) {
                setCurrentElement(element);
                element.addEventListener(
                    'play',
                    () => {
                        setCurrentTime((element as HTMLVideoElement).currentTime);
                    },
                    { once: true }
                );
                clearInterval(interval);
            }
        }, 2000);
    }, [video?._key]);

    const movePlayTimeToSelectedPosition = (time: number) => {


        if (currentElement) {

            (currentElement as HTMLVideoElement).currentTime = time;

            setCurrentTime((currentElement as HTMLVideoElement).currentTime);

            window.scrollTo({
                top: currentElement.offsetTop - 120,
                behavior: 'smooth',
            });
        }
    };

    return (
        <Wrapper>

            <Record>
                <RecordPlayer id={`video-${video._key}`} allow="fullscreen" controls>
                    <source src={video?.url} type="video/mp4" />
                </RecordPlayer>
            </Record>

            {chapters?.length > 0 && (
                <>
                    <Title>Kapitoly:</Title>
                    <Capitols>
                        {chapters?.map((chapter, key) => (
                            <Capitol onClick={() => movePlayTimeToSelectedPosition(chapter.time)} key={key} className={(currentTime >= chapter.time && (currentTime < chapters[key + 1]?.time) || (currentTime >= chapter.time && key + 1 == chapters.length)) && 'is-bold'} >
                                <CapitolTime>{secondsToHMS(chapter.time)}</CapitolTime>
                                <CapitolIcon name={Icons.Play} />
                                <CapitolTitle>
                                    {key + 1}. {chapter.title}
                                </CapitolTitle>
                            </Capitol>
                        ))}
                    </Capitols>
                </>
            )}
        </Wrapper>
    );
};

export default TrainingRecordTemplate;
